import { createFeature, createReducer, on } from '@ngrx/store';
import { PersonalParticularModel } from '@shared/data-access/models';
import * as PersonalParticularOldActions from '../actions/personal-particular-old.actions';

// note: [cms] fix(HUT-2117): reference between old & new state
export interface PersonalParticularOldState {
  detail: PersonalParticularModel | null;
}

export const initialState: PersonalParticularOldState = {
  detail: null,
};
export const personalParticularOldFeature = createFeature({
  name: 'personalParticularOld',
  reducer: createReducer(
    initialState,
    on(PersonalParticularOldActions.getDetail, (state, prop) => ({ ...state, detail: prop }))
  ),
});

export const {
  name, // feature name
  reducer, // feature reducer
} = personalParticularOldFeature;
